export default "__VITE_ASSET__BSy2$nWu__"